<script lang="ts">
import ModuleCompta from '@/generated/modules/ModuleCompta.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: ModuleCompta
})

</script>
